import { gql } from '@apollo/client';

export const GET_PROPOSAL_FOR_REVENUE = gql`
  query getProposalForRevenue($id: ID) {
    proposalRevenueInfo: proposal(id: $id) {
      proposalId
      lenderPaymentOptions {
        createdDateTime
        paymentCriteriaSelected {
          menuOption {
            products {
              title
              cost
              retailCost
              proposalProductId
            }
          }
        }
      }
    }
  }
`;
